import * as React from "react";
import {SearchBox} from "searchkit";
const isUndefined = require("lodash/isUndefined");
const isNil = require("lodash/isNil");
const isEmpty = require("lodash/isEmpty");

class CustomSearchBox extends SearchBox {

  filterUserInput(query) {
    if (isNil(query)) {
      return query;
    }
    const map = {
      '&': '',
      '<': '',
      '>': '',
      "'": '',
      '"': '\\"'
    };
    const reg = /[&<>'"]/ig;
    let filteredQeury = query.replace(reg, (match)=>(map[match]));
    return filteredQeury;
  }

  unwrapUserInput(query) {
    if (isNil(query)) {
      return query;
    }
    const map = {
      '&': '',
      '<': '',
      '>': '',
      "'": '',
      "*": '',
      '\\': ''
    };
    const reg = /[*&<>'\\]/ig;
    return query.replace(reg, (match)=>(map[match]));
  }

  searchQuery(query) {
    let filteredQuery = this.filterUserInput(query);
    let shouldResetOtherState = false;
    if (isEmpty(query)) {
      this.accessor.setQueryString(filteredQuery, shouldResetOtherState );
    } else if (filteredQuery.match('^[\\d.]*$') && filteredQuery.length > 3) {
      this.accessor.setQueryString(filteredQuery + '*', shouldResetOtherState );
    } else {
      this.accessor.setQueryString(filteredQuery, shouldResetOtherState );
    }
    let now = +new Date;
    let newSearch = now - this.lastSearchMs <= 2000;
    this.lastSearchMs = now;
    this.searchkit.performSearch(newSearch)
  }

  getAccessorValue(){
    return (this.accessor.state.getValue() || "")
  }
  getValue(){
    const { input } = this.state
    if (isUndefined(input)) {
      return this.unwrapUserInput(this.getAccessorValue())
    } else {
      return this.unwrapUserInput(input)
    }
  }

  setFocusState(focused:boolean) {
    if (!focused){
      const { input } = this.state
      if (this.props.blurAction == "search"
        && !isUndefined(input)
        && input != this.getAccessorValue()){
        this.searchQuery(this.unwrapUserInput(input));
      }
      this.setState({
        focused,
        input: undefined // Flush (should use accessor's state now)
      })
    } else {
      this.setState({ focused })
    }
  }
}
export default CustomSearchBox;



// WEBPACK FOOTER //
// ./src/CustomSearchBox.js